import api from "PFCore/api";
import { Profile } from "PFTypes";
import { Id } from "PFTypes/id";

export const editProfile = async (profileId: Id, data: object): Promise<Profile> =>
  api<Profile>({
    url: `admin/profiles/${profileId}`,
    method: "PUT",
    data
  });
